<script>
    export default {
        name: "BaseCheckbox",
        props: {
            mobileType: Boolean,
            checked: Boolean,
            text: String,
            textPosition: {
                type: String,
                default: "before",
                validator: (v) => ["before", "after"].includes(v),
            },
        },
        model: {
            prop: "checked",
            event: "change",
        },
    };
</script>

<template>
    <div class="base-checkbox" :class="{ 'base-checkbox--mobile': mobileType }">
        <span class="base-checkbox__text" v-if="text && textPosition === 'before'">
            {{ text }}
        </span>
        <label class="base-checkbox__label" :class="[`text-${textPosition}`]">
            <input
                type="checkbox"
                class="base-checkbox__input visually-hidden"
                :checked="checked"
                @change="$emit('change', !checked)"
            />
            <span class="base-checkbox__custom"></span>
        </label>
        <span class="base-checkbox__text" v-if="text && textPosition === 'after'">
            {{ text }}
        </span>
    </div>
</template>

<style lang="scss">
    .base-checkbox {
        font-size: 16px;
        line-height: 24px;
        display: flex;
        align-items: center;
        .base-checkbox__label {
            display: flex;
            align-items: center;
            max-width: 44px;
            &.text-before {
                margin-left: 12px;
            }
            &.text-after {
                margin-right: 12px;
            }
        }

        .base-checkbox__input {
            position: absolute;
            width: 1px;
            height: 1px;
            overflow: hidden;
            opacity: 0;
            &:checked + .base-checkbox__custom {
                background-color: var(--modal-control-fill);
            }
            &:checked + .base-checkbox__custom:before {
                left: 20px;
            }
            @include bp($bp-desktop-sm) {
                &:focus-visible + .base-checkbox__custom {
                    @include outline;
                }
            }
        }
        .base-checkbox__custom {
            position: relative;
            display: block;
            background: #e6e6e6;
            transition-property: background-color;
            width: 42px;
            height: 24px;
            border-radius: 100px;
            transition: background-color 0.2s linear;
            &:before {
                content: "";
                position: absolute;
                top: 2px;
                left: 2px;
                width: 20px;
                height: 20px;
                transition: left 0.2s linear;
                background: #fff;
                box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
                border-radius: 50%;
                cursor: pointer;
            }
        }
    }

    .base-checkbox--mobile {
        justify-content: space-between;
    }
</style>
